<template>
  <el-dialog
    title="岗位选择"
    :visible.sync="dialogVisible"
    width="700px"
    :close-on-click-modal="false"
    @close="closeDialog(false)"
  >
    <div class="components-position-select">
      <div class="h-100 position-select-tree border-round">
        <!-- 岗位组织树 -->
        <positionOrgTree
          @node-click="handleNodeClick"
          :showSearch="showSearch"
          :old="true"
          :multiple="multiple"
          @selectOrg="selectOrg"
          :selectedList="selectedList"
          :showCheckbox="isCheckOrg"
        />
      </div>
      <div class="h-100 position-select-table border-round relative">
        <div class="search-box">
          <div class="search-item-input">
            <el-input
              size="small"
              clearable
              v-model="searchFormData.keyword"
              placeholder="请输入岗位名称"
              @keyup.enter.native="searchPost"
            ></el-input>
          </div>
          <div class="search-item-btn">
            <el-button size="small" type="primary" @click="searchPost">查询</el-button>
          </div>
        </div>
        <div style="height:400px;">
          <el-table
            ref="checkTable"
            :data="tableData"
            height="100%"
            style="width: 100%;"
            @select-all="rowClickAll"
            @select="rowClick"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="name" label="岗位名称" show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
        <!--分页区域-->
        <div class="page-pagination-wrapper">
          <el-pagination
            small
            v-show="paginationTotal"
            @size-change="handleSizeChange"
            @current-change="getData"
            :current-page.sync="searchFormData.current"
            :page-size="searchFormData.size"
            layout="total, prev, pager, next"
            :pager-count="5"
            :total="paginationTotal"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- <div class="selectedBox" :style="computedStyle">
      <div class="arrowBtn" :class="openSign?'arrowBtnBt':'arrowBtnUp'" @click="openTab">
      </div>
      <div class="clearBtn">
        <i class="iconfont icon-qingkong1" @click="clearSelected"></i>
      </div>
      <div class="selectedWild">
        <div class="selectedCardBox" :style="computedWild">
          <el-tag
            v-for="(item,index) in selectedList"
            :key="index"
            closable
            :disable-transitions="false"
            @close="handleTagClose(item)"
            reserve-selection
          >{{item.name}}</el-tag>
        </div>
      </div>
    </div>-->
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog(false)">取 消</el-button>
      <el-button size="small" type="primary" @click="closeDialog(true)">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import positionOrgTree from "./position-organization-tree";
export default {
  name: "position-select",
  components: {
    positionOrgTree
  },
  props: {
    dataPermissions: {
      type: Boolean,
      default: false
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: true
    },
    // 是否是项目
    isPosition: {
      type: Boolean,
      default: false
    },
    checkedMap: {
      type: Array,
      default: () => []
    },
    checkedItems: {
      type: Array,
      default: () => []
    },
    selectIds: {
      //回显集合ids
      type: Array,
      default: () => []
    },
    isCheckOrg:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      searchFormData: {
        orgId: "",
        keyword: "",
        current: 1,
        size: this.$config.paginationSize,
        tagCodes: []
      },
      tableData: [],
      paginationTotal: 0,
      // defaultTagCodes: [],
      checkedItemsClone: [],
      selectedList: [],
      openSign: false,
      orgSelectedList: [], //组织选中列表
      tableSelectList: [], //表格选中列表
      dialogVisible:true
    };
  },
  computed: {
    computedStyle() {
      return { height: (this.openSign ? 200 : 72) + "px" };
    },
    computedWild() {
      return { overflowY: this.openSign ? "auto" : "hidden" };
    }
  },
  created() {
    // this.$store.dispatch("getDictionaryOrganizationTypeList").then(res => {
    //   if (this.multiple) {
    //     if (this.dataPermissions) {
    //       let temp = res.find(item => item.name === "明源");
    //       this.defaultTagCodes.push(temp.code);
    //     } else {
    //       if (res && res[0]) {
    //         this.defaultTagCodes.push(res[0].code);
    //       }
    //     }
    //   } else {
    //     this.defaultTagCodes = "oa";
    //   }
    // });
    this.search();
    this.checkedItemsClone = [...this.checkedItems];
  },
  watch: {
    selectIds(newVal, oldVal) {
      console.log(newVal);
    }
  },
  methods: {
    /**
     * 搜索
     */
    search() {
      this.searchFormData.current = 1;
      this.getData();
    },
    /**
     * 每页显示条数改变后重新搜索
     */
    handleSizeChange(val) {
      this.searchFormData.size = val;
      this.search();
    },
    /**
     * 获取数据
     */
    getData() {
      let params = { ...this.searchFormData };
      if (this.isPosition) {
        params.projectId = localStorage.getItem("projectId");
      }
      if (typeof params.tagCodes === "string") {
        params.tagCodes = [params.tagCodes];
      }
      this.$api.getPositionList(params).then(res => {
        res.body.records.forEach((item, index) => {
          item.$index =
            index +
            1 +
            (this.searchFormData.current - 1) * this.searchFormData.size;
        });
        this.tableData = res.body.records || [];
        this.$nextTick(() => {
          this.tableChecked(this.tableData);
        });
        this.paginationTotal = res.body.total;
      });
    },
    tableChecked(tableDataEdit) {
      tableDataEdit.map((row, index) => {
        this.checkedItemsClone.map(item => {
          if (item.id == row.id) {
            this.$refs.checkTable.toggleRowSelection(row, true);
          }
        });
      });
    },
    /**
     * 简单左侧树节点
     * @param data
     */
    handleNodeClick(data) {
      if (!data) {
        this.searchFormData.orgId = "";
      } else {
        this.searchFormData.orgId = data.id;
        if (data.tagCodes) {
          this.searchFormData.tagCodes = data.tagCodes;
        }
      }
      this.search();
    },
    toHeavy(arr, key) {
      for (let i = 0; i < arr.length; i++) {
        for (let j = i + 1; j < arr.length; j++) {
          if (arr[i][key] === arr[j][key]) {
            arr.splice(j, 1);
            j = j - 1; // 关键，因为splice()删除元素之后，会使得数组长度减小，此时如果没有j=j-1的话，会导致相同id项在重复两次以上之后无法进行去重，且会错误删除id没有重复的项。
          }
        }
      }
      return arr;
    },
    rowClickAll(rows) {
      if (rows.length == 0) {
        let filterArr = [];
        this.tableData.forEach(item => {
          //双重遍历去重
          this.tableSelectList.filter((el, index) => {
            if (el.id == item.id) {
              this.tableSelectList.splice(index, 1);
            }
          });
        });
      } else {
        //全选操作
        let selectListArr = [...this.tableSelectList];
        rows.map(item => {
          let have = false;
          selectListArr.map(inside => {
            if (item.id == inside.id) {
              have = true;
            }
          });
          if (!have) {
            this.tableSelectList.push(item);
          }
        });
      }
    },
    /**
     * 点击表格行
     * @param row
     */
    rowClick(rowArr, row) {
      //当前点击项是否在所有选中项集合中，若在，则为新增，若无，删除此项
      let isHave = rowArr.findIndex(el => el.id == row.id);
      if (isHave != -1) {
        //新增
        this.tableSelectList.push(row);
      } else {
        //删除
        this.tableSelectList = rowArr.filter(el => el.id != row.id);
      }
      this.selectedList = [...this.orgSelectedList, ...this.tableSelectList];
    },
    /**
     * 搜索岗位
     */
    searchPost(v) {
      this.search();
    },
    /**
     * 关闭dialog
     */
    closeDialog(type) {
      if (!type) {
        this.selectedList = [];
        this.orgSelectedList = [];
        this.tableSelectList = [];
      }
      console.log("~~~~~~~~~~~~",this.orgSelectedList,this.tableSelectList);
      this.$refs.checkTable.clearSelection();
      this.$emit(
        "handleClose",
        type,
        this.orgSelectedList,
        this.tableSelectList
      );
    },
    deleteItem(item) {
      this.selectedList = this.selectedList.filter(inside => {
        return inside.id !== item.id;
      });
    },
    clearSelected() {
      this.selectedList = [];
      this.$refs.checkTable.clearSelection();
    },
    openTab() {
      this.openSign = !this.openSign;
    },
    /**
     * 勾选的操作组织树
     * addAll：全部勾选    delAll：未勾选  addItem：勾选一项  delItem：去掉勾选一项
     */
    selectOrg(type, arr, item) {
      if (type == "addAll") this.orgSelectedList = arr;
      if (type == "delAll") this.orgSelectedList = [];
      if (type == "addItem") this.orgSelectedList.push(item);
      if (type == "delItem")
        this.orgSelectedList = arr.filter(el => el.id != item.id);

      this.selectedList = [...this.orgSelectedList, ...this.tableSelectList];
    },
    computedTitle(item) {
      let reg = /<\/?.+?\/?>/g;
      item.name = item.name.replace(reg, "");
      if (item.pathName || item.path) {
        if (item.pathName) {
          return item.name + " (" + item.pathName + ")";
        }
        if (item.path) {
          return item.name + " (" + item.path + ")";
        }
      } else {
        return item.name;
      }
    },
    /**
     * 关闭tag
     */
    handleTagClose(item) {
      this.selectedList = this.selectedList.filter(inside => {
        return inside.id !== item.id;
      });
    },
    handleSelectionChange(val) {}
  },
  mounted() {
   
  }
};
</script>
<style lang="scss" scoped>
.components-position-select {
  height: 500px;
  display: flex;
  > .position-select-tree {
    width: 300px;
    flex-shrink: 0;
  }
  > div.position-select-table {
    flex: 1;
  }
}

.h-100 {
  height: 100%;
}

.position-select-tree {
  overflow-y: auto;
  overflow-x: hidden;
}

.position-select-table {
  padding-bottom: 90px;
  border-left: none;
}

.page-pagination-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.page-pagination-wrapper {
  padding: 10px 0;
}

.search-box {
  display: flex;
  margin-top: 10px;
  margin-right: 10px;

  .search-item-input {
    flex: 2;
    margin-left: 10px;
    margin-right: 10px;
  }
}

.arrowBtnUp {
  background: url("../common/images/expandUp.png") no-repeat;
}
.arrowBtnBt {
  background: url("../common/images/expandBt.png") no-repeat;
}

.clearBtn {
  position: absolute;
  right: 3px;
  top: 0px;
  width: 16px;
  height: 16px;
  /*        background: #CDCFD4;*/
  text-align: center;
  line-height: 16px;
}

.selectedBox {
  width: calc(100% + 5px);
  position: relative;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(205, 207, 212, 1);
  z-index: 20;
  transition: height 0.5s;

  .arrowBtn {
    position: absolute;
    background: #fff;
    top: -11px;
    left: 332px;
    display: inline-block;
    width: 60px;
    height: 11px;
    line-height: 11px;
    cursor: pointer;
    z-index: 21;
    text-align: center;
    background-size: 100% 100%;

    i {
      font-size: 12px;
    }
  }
  .arrowBtnUp {
    background: url("../common/images/expandUp.png") no-repeat;
  }
  .arrowBtnBt {
    background: url("../common/images/expandBt.png") no-repeat;
  }

  .clearBtn {
    position: absolute;
    right: 3px;
    top: 0px;
    width: 16px;
    height: 16px;
    /*        background: #CDCFD4;*/
    text-align: center;
    line-height: 16px;
  }

  .selectedWild {
    height: 100%;

    .selectedCardBox {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-content: flex-start;
      height: 100%;
      padding: 10px 24px;
      .el-tag {
        margin-right: 10px;
        margin-bottom: 10px;
      }
    }
  }
}
</style>